import { render, staticRenderFns } from "./DomainAuthenticateFormDomain.vue?vue&type=template&id=012130a9&scoped=true"
import script from "./DomainAuthenticateFormDomain.vue?vue&type=script&lang=js"
export * from "./DomainAuthenticateFormDomain.vue?vue&type=script&lang=js"
import style0 from "./DomainAuthenticateFormDomain.vue?vue&type=style&index=0&id=012130a9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012130a9",
  null
  
)

export default component.exports